import axios from './axios'
import store from 'shared/redux/store'
import { showSuccess, showError } from 'shared/redux/app/reducer'
import axiosLib, { AxiosRequestConfig, AxiosResponse } from 'axios'

export interface UploadLinkResponse {
  file_path: string
  [k: string]: any | undefined
}

export default async function getUploadLinkService(
  config: AxiosRequestConfig,
  filename: string,
  file_type = '',
  file_sub_path = '',
  token = '',
  token_type = '',
): Promise<UploadLinkResponse> {
  try {
    const source = axiosLib.CancelToken.source()
    let response
    if (token && token_type) {
      response = await axios({
        url: `/asset/public/upload/${filename}`,
        method: 'GET',
        params: {
          file_type,
          file_sub_path,
          token,
          token_type,
        },
        cancelToken: source.token,
      })
    } else {
      response = await axios({
        url: `/asset/upload/${filename}`,
        method: 'GET',
        params: {
          file_type,
          file_sub_path,
        },
        cancelToken: source.token,
      })
    }

    const uploadLinkResponse: UploadLinkResponse = (response as unknown) as UploadLinkResponse

    if (!uploadLinkResponse || !uploadLinkResponse.file_path) {
      throw new Error('Unable to get upload link.')
    }

    return {
      file_path: uploadLinkResponse.file_path,
    }
  } catch (error) {
    store.dispatch(
      showError({
        message: error.message || 'An unknown error occurred',
      }),
    )
    throw error
  }
}
